<ul class='simple-accordion compact'>
  <ng-content></ng-content>
</ul>
